import React from "react";
import authenticationService from "../../../services/common-services/authentication-service";
import appMessageService, {
  messageType,
} from "../../../services/common-services/app-message-service";

export function useDropdownMenuHook() {
  const handleGetSwitchAccountCode = React.useCallback(() => {
    appMessageService.messageFactory({
      type: messageType.WARNING,
      title: "Chuyển tài khoản",
      description:
        "Vui lòng chờ trong dây lát, hệ thống đang thực hiện chuyển trang",
    });
    authenticationService.getSwitchAccountCode().then((res: any) => {
      if (res.data) {
        const currentPage = `${window.location.protocol}//${window.location.hostname}/landing-page`;
        window.location.href = `${res.directUrl}/switchAccount?redirect_url=${currentPage}&code=${res.data}`;
      }
    });
  }, []);

  return {
    handleGetSwitchAccountCode,
  };
}
